import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import _ from "lodash";
import { getMessage } from "CONFIG/i18n";

// Images
import KurentoServer from "ASSETS/Images/ic_Kurento_Monitoring_Server.svg";
import ServerOn from "ASSETS/Images/ic_server_on.svg";
import ServerOff from "ASSETS/Images/ic_server_off.svg";

// Styles
import "./OrganisationsSummary.less";

/**
 * OrganisationsSummary Component
 * 
 * Displays a summary of organization data along with Kurento Media Server (KMS) status.
 * The component is divided into two sections:
 * 1. Displays summary data items in a grid layout with values and labels
 * 2. Shows the KMS server status with an icon indicator
 * 
 * @param {Object} props - Component props
 * @param {Array<Object>} props.summaryData - Array of summary items to display
 * @param {string} props.summaryData[].value - The value to display for each summary item
 * @param {string} props.summaryData[].label - The label to display for each summary item
 * @param {boolean} props.isKurentoServerOn - Flag indicating whether the Kurento Media Server is online
 * 
 * @returns {JSX.Element} A row containing organization summary data and server status
 * 
 */
class OrganisationsSummary extends Component {
  render() {
    const { summaryData, isKurentoServerOn } = this.props;

    return (
      <Row className="summary">
        <Col lg={10} className="borderRight noPadding">
          <Row className="fitHeaderContent">
            {_.map(summaryData, (item, index) => {
              return (
                <Col lg={2} key={index} className="summaryDiv">
                  <div className="summaryValue nameEllipsis" title={item.value}>
                    {item.value}
                  </div>
                  <div className="summaryLabel">
                    {item.label}
                  </div>
                </Col>
              );
            })}
          </Row>
        </Col>
        
        <Col lg={2} className="serverInfo px-lg-0 px-md-0">
          <div className="pt-4 pb-3 displayFlex justifyContentFlexCenter alignItemsCenter">
            {isKurentoServerOn ? (
              <img className="mr-2" src={ServerOn} alt="Server On" />
            ) : (
              <img className="mr-2" src={ServerOff} alt="Server Off" />
            )}
            <img className="mr-2" src={KurentoServer} alt="KMS" />
            <div>{getMessage("KMS")}</div>
          </div>
        </Col>
      </Row>
    );
  }
}

export default OrganisationsSummary;